//记得在 src\components\lang\zhLoad.js 里面添加对象
const taskList = {
  taskId:'Task ID',
  taskName: 'Task Name',
  taskType: 'Task Type',
  region: 'Region',
  applicableArea: 'Applicable Area',
  taskCycle: 'Task Cycle',
  claimed: 'Claimed',
  status: 'Status',
  homefeed:'Home Feed',
  homeRankings:'Home Rankings',
  taskPkgMustFlag: 'Required',
  creatorName: 'Creator',
  msg: {}
};
export default taskList



// WEBPACK FOOTER //
// ./src/page/taskManagement/taskList/lang/taskList.en.js